import { KeyValue } from '@/main/models/common';
import React, { createContext,  useContext, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';


interface IValuatorRegisterProvider {
  children: React.ReactNode;
}

interface IValuatorRegisterContext {
  isEdit: boolean;
  setIsEdit: (value: boolean) => void;
}

export interface IValuatorRegisterForm {
  country: KeyValue | null | undefined;
  name: string;
  rfc: string;
  statusRegister: KeyValue | null;
  insurer: KeyValue | null;
}

const INITIAL_FORM_STATE: IValuatorRegisterForm = {
  country: null,
  name: '',
  rfc: '',
  statusRegister: null,
  insurer: null
};

const ValuatorregisterContext = createContext<IValuatorRegisterContext>({
  isEdit: false,
  setIsEdit: () => {}
});

export function ValuatorRegisterProvider({
  children
}:IValuatorRegisterProvider) {
  const methods = useForm<IValuatorRegisterForm>({
    mode: 'onChange',
    defaultValues: INITIAL_FORM_STATE
  });

    const [isEdit, setIsEdit] = useState(false);

  return (
    <FormProvider {...methods}>
      <ValuatorregisterContext.Provider value={{isEdit, setIsEdit}}>
        {children}
      </ValuatorregisterContext.Provider>
    </FormProvider>
  );
}

export const useValuatorRegisterContext = () => useContext(ValuatorregisterContext);